window.ParticipantsUsers = {
  initialize() {
  },
  selectedTemplate: _.template(`<tr id='selectedCompaniesColleagues<%= id %>'>
    <td>
    <div class='right'>
    <a href='#' class='remove-company-colleague' data-id='<%= id %>'><i class='pti pt-close'></i></a>
    </div>
    <p>
    <i class='pti pt-user'></i>
    <%= name %>
    </p>
    <input name='tender[user_invitations_attributes][<%= id %>][user_id]'
    type='hidden' value='<%= id %>' />
    </td>
    </tr>`),
      participantType: 'colleague' 
};